__turbopack_context__.v({
  "body": "CourseCTACard-module__HmZLva__body",
  "card": "CourseCTACard-module__HmZLva__card",
  "content": "CourseCTACard-module__HmZLva__content",
  "contentTop": "CourseCTACard-module__HmZLva__contentTop",
  "cornerDots": "CourseCTACard-module__HmZLva__cornerDots",
  "description": "CourseCTACard-module__HmZLva__description",
  "imageWrapper": "CourseCTACard-module__HmZLva__imageWrapper",
  "infoItem": "CourseCTACard-module__HmZLva__infoItem",
  "infoLabel": "CourseCTACard-module__HmZLva__infoLabel",
  "infoValue": "CourseCTACard-module__HmZLva__infoValue",
  "selectionInfo": "CourseCTACard-module__HmZLva__selectionInfo",
  "title": "CourseCTACard-module__HmZLva__title",
});
